import { render, staticRenderFns } from "./BrushstrokeBanner.vue?vue&type=template&id=afffa7e0&scoped=true&"
import script from "./BrushstrokeBanner.vue?vue&type=script&lang=js&"
export * from "./BrushstrokeBanner.vue?vue&type=script&lang=js&"
import style0 from "./BrushstrokeBanner.vue?vue&type=style&index=0&id=afffa7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afffa7e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
